import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { generatePdf, getRandomString } from 'src/app/utils/common.utils';
import * as moment from "moment-timezone";
import { isiReportDownload } from 'src/app/components/reports/pdf-make-reports/configuration-report';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { timeZone } from 'src/app/utils/utils.common';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { rnsInvoiceDownload } from '../../reports/pdf-make-reports/rns-invoice';
import { TitleCasePipe } from '@angular/common';
import * as _ from 'lodash';
@UntilDestroy()
@Component({
  selector: 'app-report-configuration-modal',
  templateUrl: './report-configuration-modal.component.html',
  styleUrls: ['./report-configuration-modal.component.css']
})
export class ReportConfigurationModalComponent implements OnInit {
  @Input() source?: string;
  @Input() reportSource?: string;
  @Input() selectedTrips: any;
  @Input() user: any;
  @Input() selectedCorporate: any;
  // @Input() filterdataList: any;
  @Input() preLevelOfService: any;
  @Output() onCloseModal = new EventEmitter<any>();
  configurationForm!: FormGroup;
  trips:any = [];
  @Input() todayDate: any;
  tripId:any
  tripData:any
  timeZone:any = timeZone;
  reportLoader = {
    isModal: false,
    isLoading: false,
  };
  selectedTripIds:any;
  companies: any = [];
  preCompanies: any = {};

  fundingSources: any = [];
  preFundingSources: any = {};
  selectedCompanyId: any = '';
  selectedFundingSourceId: any = '';
  submitted = false;
  titleCase = new TitleCasePipe();

  constructor(private fb: FormBuilder,
    private tripService: TripService,
    private billingService : BillingService,
    private credentialService : CredentialService,
    private sharedDataService : SharedDataService,
    private fundingSourceService: FundingSourceService
  ) { }

  ngOnInit() {
      this.selectedTripIds = this.selectedTrips.map((trip:any) => trip.id);
      this.configurationForm = this.fb.group({
      invoiceNo: [this.generateString()],
      billingCompany: ['', Validators.required],
      billingAddress: ['',Validators.required],
      billingCompanyPhone: ['',Validators.required],
      billingCompanyEmail: [''],
      preInvoiceDate: [moment().toISOString()],
      invoiceDate: [moment().toISOString()],
      dueDate: [moment().tz(this.user?.timeZone).startOf('day').add(1,'week').toISOString()],
      preDueDate: [moment().tz(this.user?.timeZone).startOf('day').add(1,'week').toISOString()],
      outstandingInvoiceNo: [''],
      pastDue: [0],
    })
    this.getUser()

    if (this.user) {
      this.configurationForm.patchValue({
        billingCompany: this.user.company,
        billingCompanyEmail: this.user.email,
      })
    }
    // this.trips = this.selectedTrips.length ? this.getSelectedTrips() : this.filterdataList;
    this.trips = this.selectedTrips;
    this.trips = this.trips.sort(
        (a:any, b:any) => moment(a?.pickup?.time).valueOf() - moment(b?.pickup?.time).valueOf()
      );

  }

  get form(){
    return this.configurationForm.controls
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.user.timeZone) {
          this.timeZone = this.user.timeZone;
        }
        // this.todayDate = [
        //   moment().tz(this.timeZone).startOf("day"),
        //   moment().tz(this.timeZone).endOf("day"),
        // ];
      }
    });
    this.getCompanies();
    this.getFundingSources();
  }

  getCompanies() {
  this.credentialService
    .getPicker({ isActive: true, limit: 9999 })
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          const tripCompanyIds = _.uniq(this.selectedTrips.map((trip: any) => trip.company));
          this.companies = data.results.filter((company: any) => tripCompanyIds.includes(company.id))
            .sort((a: any, b: any) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
          this.preCompanies = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  getFundingSources() {
    this.fundingSourceService
      .getPicker({ isActive: true, limit: 9999 })
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          const tripFundingSourceIds = _.uniq(this.selectedTrips.map((trip: any) => trip.fundingsource));
          this.fundingSources = data.results.filter((fs: any) => tripFundingSourceIds.includes(fs.id))
            .sort((a: any, b: any) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));
          this.preFundingSources = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  generateString() {
    const randomString = getRandomString(7)
    const dateTime = moment().format('MMDDYY')
    return `${randomString}-${dateTime}`;
  }

   getTripDetails() {
    this.tripService.getTripById(this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.tripData = data
      }
    })
  }

  changeInvoiceDate(event:any) {
    this.configurationForm.patchValue({
      invoiceDate: moment(event).toISOString(),
      dueDate: moment(event).tz(this.user?.timeZone).startOf('day').add(1,'week').toISOString(),
      preDueDate: moment(event).tz(this.user?.timeZone).startOf('day').add(1,'week').toISOString(),
    })

  }
  changeDueDate(event:any) {
    this.configurationForm.patchValue({
      dueDate: moment(event).tz(this.user?.timeZone).startOf('day').toISOString()
    })

  }



 downloadTripReport() {
  if(this.reportSource === 'rnsinvoice') {
    this.rnsReport();
  }else {
     this.paramountReport();
  }
  
}

async rnsReport() {
  this.submitted = true;
  if(this.configurationForm.invalid){
    return
  }
  this.reportLoader.isLoading = true;
  this.reportLoader.isModal = true;

  const queryParams = {
    time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    selectedIds: this.selectedTripIds
  };

  (this.source === 'billing' 
    ? this.billingService.getReportTrips(queryParams) 
    : this.billingService.getFsReportTrips(queryParams)
  ).subscribe({
      next: async (trips: any) => {
        if (trips && trips.length) {
          this.tripData = trips;

          try {
            const detailsObject = await rnsInvoiceDownload(
              this.tripData,
              this.user,
              this.configurationForm.value,
              this.preLevelOfService,
              this.selectedCorporate
            );
            const invoiceName = 'RNS Invoice';
            await generatePdf(detailsObject, "download", invoiceName);
          } catch (err) {
            console.error("Error generating Trip report:", err);
          } finally {
            this.reportLoader.isLoading = false;
          }
        } else {
          this.reportLoader.isLoading = false;
        }
      },
      error: (err) => {
        console.error("Error fetching trips:", err);
        this.reportLoader.isLoading = false;
      }
    });
}

async paramountReport() {
  this.submitted = true;
  if(this.configurationForm.invalid){
    return
  }
  this.reportLoader.isLoading = true;
  this.reportLoader.isModal = true;

  const queryParams = {
    time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
    selectedIds: this.selectedTripIds
  };

  (this.source === 'billing' 
    ? this.billingService.getReportTrips(queryParams) 
    : this.billingService.getFsReportTrips(queryParams)
  ).subscribe({
      next: async (trips: any) => {
        if (trips && trips.length) {
          this.tripData = trips;

          try {
            const detailsObject = await isiReportDownload(
              this.tripData,
              this.user,
              this.configurationForm.value,
              this.preLevelOfService,
              this.selectedCorporate,
              this.source
            );
            const invoiceName = 'Trip-report';
            await generatePdf(detailsObject, "download", invoiceName);
          } catch (err) {
            console.error("Error generating Trip report:", err);
          } finally {
            this.reportLoader.isLoading = false;
          }
        } else {
          this.reportLoader.isLoading = false;
        }
      },
      error: (err) => {
        console.error("Error fetching trips:", err);
        this.reportLoader.isLoading = false;
      }
    });
}


  closeModal(){
    this.onCloseModal.emit();
  }


  // getSelectedTrips() {
  //   return this.filterdataList.filter((trip:any) => trip.isSelected);
  // }

  onSelectCompany(companyId: any) {
    this.selectedFundingSourceId = '';
    this.clearBillingInfo();
    const company = this.preCompanies[companyId];
    if (company) {
      this.configurationForm.patchValue({
        billingCompany: company.name,
        billingAddress: company?.address.name || '',
        billingCompanyPhone: company.phoneNumber,
        billingCompanyEmail: company.email
      });
    }
  }

  onSelectFundingSource(fundingSourceId: any) {
    this.selectedCompanyId = '';
    this.clearBillingInfo();
    const fundingSource = this.preFundingSources[fundingSourceId];
    if (fundingSource) {
      this.configurationForm.patchValue({
        billingCompany: this.titleCase.transform(fundingSource.title),
        billingAddress: fundingSource?.address.name || '',
        billingCompanyPhone: fundingSource.contactNumber,
        billingCompanyEmail: fundingSource.email
      });
    }
  }

  clearBillingInfo() {
    this.configurationForm.patchValue({
      billingCompany: '',
      billingAddress: '',
      billingCompanyPhone: '',
      billingCompanyEmail: '',
    });
  }

}
